import {FileUploadHeaderTemplateOptions} from 'primereact/fileupload'
import React from 'react'

export const headerTemplate = (options: FileUploadHeaderTemplateOptions, showUpload = false) => {
	const {className, chooseButton, cancelButton, uploadButton} = options

	return (
		<div
			key="upload" className={className} style={
			{backgroundColor: 'transparent', display: 'flex', alignItems: 'center'}
		}>
			{chooseButton}
			{showUpload && uploadButton}
			{cancelButton}
		</div>
	)
}